import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import { Spinner } from '../components/Elements';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import { useUser } from '../config/connection/auth';
import { ConfirmarCadastro } from '../features/auth/routes/ConfirmarCadastro';

export const Routes = () => {
  const auth = useUser();
  const location = useLocation();

  // Sem login, a página pedida vai junto para o login voltar a ela (link aberto em nova
  // aba, sessão expirada). Só caminhos de dentro do app, para não virar redirecionamento aberto.
  const pedida = location.pathname.startsWith('/app/') ? `?voltar=${encodeURIComponent(location.pathname + location.search)}` : '';
  const commonRoutes = [{ path: '*', element: auth.data ? <Navigate to="/app/dashboard" /> : <Navigate to={`/auth/login${pedida}`} />, replace: true }];

  // o typeof(auth.data) !== "string" é porque quando auth.data for uma string significa que o back retornou um erro, e auth.data é a mensagem desse erro,
  // que deve ser mandada como notificação na tela
  const routes = auth.data && typeof(auth.data) !== "string" ? protectedRoutes : publicRoutes;
  
  // const routes = auth.data ? protectedRoutes : publicRoutes; // tenho que lembrar por que eu fiz isso kkkkkkkkkkkkkkk

  // A confirmação do cadastro vale logado ou não: quem abre o link do e-mail com outra conta aberta
  // (ex. o adm criando um usuário de teste) seria jogado no Dashboard e a conta nunca seria confirmada.
  const sempre = [{ path: '/auth/confirmar', element: <ConfirmarCadastro /> }];

  const element = useRoutes([...sempre, ...routes, ...commonRoutes]);

  // Enquanto o /auth/me não respondeu, não se sabe se há alguém logado. Antes as rotas
  // públicas entravam nesse meio-tempo e o "*" mandava para o login, que por sua vez
  // jogava no Dashboard: todo link aberto direto (como "Abrir em nova aba") se perdia.
  if (auth.isLoading) {
    return <div className="spinner-container"><Spinner /></div>;
  }

  return <>{element}</>;
};